import Vue from "vue";
import Router from "vue-router";

import routeName from "./lib/const/routeName";
import LoginContent from "./components/LoginContent";
import LogoutContent from "./components/LogoutContent";
import ThankYouContent from "./components/ThankYouContent";
import UserListContent from "./components/UserListContent";

function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `./components/${view}.vue`);
}

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: routeName.HOME_CONTENT,
      component: UserListContent,
    },
    {
      path: "/about",
      name: routeName.ABOUT_CONTENT,
      component: loadView("AboutContent"),
    },
    {
      path: "/login",
      name: routeName.LOGIN_CONTENT,
      component: LoginContent,
    },
    {
      path: "/logout",
      name: routeName.LOGOUT_CONTENT,
      component: LogoutContent,
    },
    {
      path: "/thank-you",
      name: routeName.THANK_YOU_CONTENT,
      component: ThankYouContent,
    },
    {
      path: "/users",
      name: routeName.USER_LIST_CONTENT,
      component: UserListContent,
    },
    {
      path: "/users/info",
      name: routeName.USER_INDIVIDUAL_UPDATE_CONTENT,
      component: loadView("UserIndividualContent"),
    },
    {
      path: "/users/new",
      name: routeName.USER_INDIVIDUAL_CREATION_CONTENT,
      component: loadView("UserIndividualContent"),
    },
  ],
});

export default router;
